import { render, staticRenderFns } from "./TermsAndConditionsPage.es.vue?vue&type=template&id=27c18b96"
import script from "./TermsAndConditionsPage.es.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.es.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports